import Mutations from '../../odata/mutations';

export default { ...new Mutations('hubSpotCompany'), ...new Mutations('hubSpotCompanies') };
